export type BudgetDisplayNameData = {
  name: string;
  year: number;
};

export function budgetDisplayName({
  name,
  year,
}: BudgetDisplayNameData): string {
  return `${name} (${year})`;
}
